import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Handshake, TrendingUp } from "lucide-react";
export default function UnlockTheBenefitsOfStrategicProcurement() {
  const benefits = [{
    id: 1,
    icon: DollarSign,
    title: "Significant Cost Savings",
    description: "Optimize your supply chain and reduce procurement expenses through strategic vendor relationships and efficient processes."
  }, {
    id: 2,
    icon: Handshake,
    title: "Improved Vendor Relationships",
    description: "Build stronger, more reliable partnerships with suppliers that align with your business objectives and values."
  }, {
    id: 3,
    icon: TrendingUp,
    title: "Streamlined Procurement Processes",
    description: "Eliminate bottlenecks and inefficiencies with expert guidance on contract management and vendor selection."
  }];
  return <section className="bg-background py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mb-12 animate-fade-in-up">
          <h2 className="text-foreground text-4xl font-bold mb-4">
            Unlock the Benefits of Strategic Procurement
          </h2>
          <p className="text-muted-foreground text-lg">
            Aran Group's Turnkey Vendor/Procurement Advisory service empowers your business with expert supply chain management and vendor optimization.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <Card key={benefit.id} data-index={i} className="card hover-lift px-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <CardHeader>
                  <div className="mb-4 inline-flex items-center justify-center size-12 rounded-lg bg-primary/10">
                    <Icon className="size-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl">{benefit.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}